import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  AUTH_USER_LOAD,
  GET_DASHBOARD_DATA,
  ACCESS_TOKEN_SUCCESS,
  ACCESS_TOKEN_ERROR,
  GET_CONTACTS,
} from "../constant/Type";

const initialState = {
  isAuthenticated: null,
  user: null,
  dashboard: null,
  loading: true,
  token: localStorage.getItem("technowren") || "",
  contact: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_DATA:
      return {
        ...state,
        dashboard: action.payload,
        loading: false,
      };
    case GET_CONTACTS:
      return {
        ...state,
        contact: action.payload,
        loading: false,
      };

    case ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
      };

    case AUTH_USER_LOAD:
      return {
        ...state,
        user: [...action.payload],
        loading: false,
      };

    case LOGIN_FAIL:
    case LOGOUT_SUCCESS:
    case ACCESS_TOKEN_ERROR:
      localStorage.removeItem("technowren");
      return {
        ...state,
        token: "",
        user: null,
        isAuthenticated: false,
        loading: false,
      };
    case ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        token: action.payload,
        isAuthenticated: true,
        loading: false,
      };
    case ACCESS_TOKEN_ERROR:
      return {
        ...state,
        err: action.payload,
        isAuthenticated: false,
        loading: false,
      };

    default:
      return state;
  }
};

export default authReducer;
